// extracted by mini-css-extract-plugin
export default {"logo":"LogoWithText_logo__nXlP1"};